import React, { useState } from 'react'
import "./ProfileInfo.css"
import { useDispatch, useSelector } from 'react-redux';
import Toast from 'react-bootstrap/Toast';
import { Nav, Spinner, Tab, ToastContainer } from 'react-bootstrap';
import axios from 'axios';
import { loginMethod } from '../../hook/auth';
import { data } from 'react-router-dom';
import AlertContainer from '../Alert/Alert';

function ProfileInfo() {
  const userinfo = useSelector((state) => state);
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState('');
  const [severity, setSeverity] = useState('');
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState(userinfo.auth.userArray?.phone);

  const [name, setName] = useState(userinfo.auth.userArray?.name);
  const [email, setEmail] = useState(userinfo.auth.userArray?.email);
  const dispatch = useDispatch();
  console.log(userinfo?.auth?.access_token);


  const changeProfile = async () => {
    setLoading(true)
    await axios
      .post(`https://nanosoft.technology/smile/api/client/update-profile`, {
        email: email,
        name: name,
        phone: phone
      }, {
        headers: {
          Authorization: `Bearer ${userinfo?.auth?.access_token}`
        }
      })
      .then(async (res) => {

        // setShow(true)
          setLoading(false)
          setShow(true)
          setMsg(currentLocal.home.successMessage)
              dispatch(loginMethod({
          data: res.data.data,
          access_token: userinfo?.auth?.access_token
        }))
          setSeverity("success")
                    setTimeout(() => {
            setShow(false);
            setMsg("")

  
          }, 2000);
  
      })
      .catch((error) => {
          setLoading(false)
          setShow(true)
          setMsg(msg)
          setSeverity("error")

      });

  }
  return (
    <section className='profile_info_container'>

      {show&&
                    <AlertContainer
                    msg={msg}
                    severity={severity}
                    />
              
                    }
      <h3>{currentLocal.home.yoursecurity}</h3>
      <div className='profile_info_box'>
        <Tab.Container defaultActiveKey="profile">

          <Nav variant="tabs" defaultActiveKey="/profile">
            <Nav.Item>
              <Nav.Link eventKey="profile">{currentLocal.home.UserProfile}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="edit">{currentLocal.home.UpdateProfile}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="password">{currentLocal.home.changePassword}</Nav.Link>
            </Nav.Item>
            <Nav.Item>

            </Nav.Item>
          </Nav>

          <Tab.Content className="mt-3">
            <Tab.Pane eventKey="profile">
              <div>
                <div className='mt-5 d-flex'>
                  <p className='fw-bold'>{currentLocal.home.namePlaceholder} :</p>
                  <p className='mx-3'>{userinfo.auth.userArray?.name}</p>


                </div>

                <div className=' d-flex'>
                  <p className='fw-bold'>{currentLocal.home.emailPlaceholder} :</p>
                  <p className='mx-3'>{userinfo.auth.userArray?.email}</p>
                </div>

                <div className=' d-flex'>
                  <p className='fw-bold'>{currentLocal.home.phonePlaceholder} :</p>
                  <p className='mx-3'>{userinfo.auth.userArray?.phone}</p>
                </div>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="edit">
              <div>
                <div className='mt-4 mb-0'>
                  <p className='fw-bold'>{currentLocal.home.namePlaceholder} :</p>
                  <input
                    value={name}
                    onChange={(e) => {
                      setShow(false)
                      setName(e.target.value)}}
                  />


                </div>

                <div className=' '>
                  <p className='fw-bold mb-0'>{currentLocal.home.emailPlaceholder} :</p>
                  <input
                    value={email}
                    onChange={(e) => {
                                            setShow(false)

                      setEmail(e.target.value)}}

                  />
                </div>

                <div className=' '>
                  <p className='fw-bold mb-0'>{currentLocal.home.phonePlaceholder} :</p>
                  <input
                    value={phone}
                    onChange={(e) => {
                                            setShow(false)

                      setPhone(e.target.value)}}

                  />
                </div>
                <div className='d-flex justify-content-center w-100 flex-row mt-3'>
                  <div className='btn_container ' onClick={changeProfile}>
                    {loading &&
                      <Spinner animation="border" role="status" size="sm" className='mt-1'>
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>}
                    <p className='mb-0 mx-2'>
                      {currentLocal.home.Save}

                    </p>

                  </div>
                </div>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="password">
              <div >
                <div style={{ position: "relative" }} className='mt-4 mb-0 '>

                  <p className='fw-bold'>{currentLocal.home.Oldpassword}:</p>
                  <input
                    placeholder='Enter your password'
                  />

                  <div className='icon_container'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                    </svg>
                  </div>
                </div>

                <div style={{ position: "relative" }}>
                  <p className='fw-bold mb-0'>{currentLocal.home.Newpassword} :</p>
                  <input
                    placeholder='Enter your password'


                  />

                  <div className='icon_container'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                    </svg>
                  </div>
                </div>

                <div style={{ position: "relative" }}>
                  <p className='fw-bold mb-0'>{currentLocal.home.Confirmpassword} :</p>
                  <input
                    placeholder='Re-enter your password.'
                  />
                  <div className='icon_container'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                    </svg>
                  </div>
                </div>
                <div className='d-flex justify-content-center w-100 flex-row mt-3'>
                  <div className='btn_container'>
                    {currentLocal.home.Save}

                  </div>
                </div>
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
        {/* <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item">
            <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">User Profile</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Update Profile</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">Change Password</a>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <div className='mt-5 d-flex'>
              <p className='fw-bold'>Name  :</p>
              <p className='mx-3'>{userinfo.auth.userArray.client?.name}</p>


            </div>

            <div className=' d-flex'>
              <p className='fw-bold'>Email :</p>
              <p className='mx-3'>{userinfo.auth.userArray.client?.email}</p>
            </div>

            <div className=' d-flex'>
              <p className='fw-bold'>Phone :</p>
              <p className='mx-3'>{userinfo.auth.userArray.client?.phone}</p>
            </div>
          </div>
          <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <div className='mt-4 mb-0'>
              <p className='fw-bold'>Name  :</p>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
              />


            </div>

            <div className=' '>
              <p className='fw-bold mb-0'>Email :</p>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}

              />
            </div>

            <div className=' '>
              <p className='fw-bold mb-0'>Phone :</p>
              <input
                value={phone}
                onChange={(e) => setPhone(e.target.value)}

              />
            </div>
            <div className='d-flex justify-content-center w-100 flex-row mt-3'>
              <div className='btn_container ' onClick={changeProfile}>
          {loading&&      <Spinner animation="border" role="status"size="sm"className='mt-1'>
                  <span className="visually-hidden">Loading...</span>
                </Spinner>}
                <p className='mb-0 mx-2'>
                  Save Chane

                </p>

              </div>
            </div>
          </div>
          <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
            <div className='mt-4 mb-0 input_container'>
              <p className='fw-bold'>Old Password  :</p>
              <input
                placeholder='Enter your password'
              />

              <div className='icon_container'>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                  <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                </svg>
              </div>
            </div>

            <div className='input_container'>
              <p className='fw-bold mb-0'>New Password :</p>
              <input
                placeholder='Enter your password'


              />

              <div className='icon_container'>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                  <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                </svg>
              </div>
            </div>

            <div className='input_container'>
              <p className='fw-bold mb-0'>Confirm Password :</p>
              <input
                placeholder='Re-enter your password.'
              />
              <div className='icon_container'>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                  <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                </svg>
              </div>
            </div>
            <div className='d-flex justify-content-center w-100 flex-row mt-3'>
              <div className='btn_container'>
                Save Chane

              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section >
  )
}

export default ProfileInfo